import { ReasoningItem } from "@/modules/vendors/types";
import { Drawer, DrawerBody, DrawerContent, DrawerHeader } from "@/shared/components/drawer";
import { Button } from "@nextui-org/react";
import { X } from "lucide-react";
import React from "react";

interface ReasoningDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  reasoningItems?: ReasoningItem[];
}

const ReasoningDrawer: React.FC<ReasoningDrawerProps> = ({ isOpen, onClose, reasoningItems }) => {
  // Use provided reasoning items or show empty state
  const items = reasoningItems && reasoningItems.length > 0 ? reasoningItems : [];

  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      placement={"right" as any}
      hideCloseButton
    >
      <DrawerContent className="h-full flex flex-col rounded-r-none border-l border-[#E4E4E7] w-[480px]">
        <DrawerHeader className="border-b border-[#E4E4E7] p-4 flex flex-col">
          <div className="flex justify-between items-center w-full">
            <h2 className="text-lg font-medium">Reasoning</h2>
            <Button
              isIconOnly
              variant="light"
              onPress={onClose}
              className="w-4 h-4 min-w-0 p-0 text-[#777780] data-[hover=true]:bg-transparent data-[focus=true]:bg-transparent data-[focus-visible=true]:outline-none"
            >
              <X size={16} />
            </Button>
          </div>
        </DrawerHeader>

        <DrawerBody className="overflow-y-auto p-4 flex-grow">
          {items.length > 0 ? (
            <div className="flex flex-col gap-[12px]">
              {items.map((item, index) => (
                <div key={index} className="flex flex-col items-start gap-[12px] p-0 w-full">
                  {/* Badge/Tag - Frame 6746 */}
                  <div className="flex flex-col justify-center items-center px-[8px] py-[2px] gap-[4px] h-[20px] bg-[#FAFAFA] border border-[#E4E4E7] rounded-[24px]">
                    <span className="font-['Inter'] font-normal text-[12px] leading-[16px] flex items-center text-center text-[#3F3F46]">
                      Question {item.follow_up_question_index !== undefined ? item.follow_up_question_index + 1 : index + 1}
                    </span>
                  </div>

                  {/* Content Container - Frame 6773 */}
                  <div className="flex flex-col items-start gap-[8px] w-full">
                    {/* Title - Parsing response structure */}
                    <div className="w-full font-['Inter'] font-normal text-[14px] leading-[20px] flex items-center text-[#3F3F46]">
                      {item.title}
                    </div>

                    {/* Description - Breaking down... */}
                    <div className="w-full font-['Inter'] font-normal text-[14px] leading-[20px] flex items-center text-[#71717A]">
                      {item.description}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="flex items-center justify-center h-full text-sm text-[#71717A]">
              No reasoning data available
            </div>
          )}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default ReasoningDrawer;

